<template>
        <section class="user_section">
            <UserLnb :navTitle="navTitle" :bgStyle="'type2'" />
            <div class="title jc">
                <h2>탕전실 둘러보기</h2>
            </div>
                                  
            <article class="view intro slide_wrap w1200">
                <div class="main_slide">
                    <swiper class="swiper mySwiper swiper-wrapper" :options="swiperOption"
                            :navigation="true"
                            ref="mainSwiper"
                        >
                        <swiper-slide v-for="(item, idx) in imagesList" :key="idx" >
                            <div class="img_box"><img :src="item.img" alt=""></div>
                        </swiper-slide>

                    </swiper>
                        <div class="control_wrap">
                            <div class="swiper-prev" slot="button-prev"><b-icon icon="chevron-left"></b-icon></div>
                            <div class="swiper-next" slot="button-next"><b-icon icon="chevron-right"></b-icon></div>
                        </div>                    
                </div>
                <div class="thumb_slide">
                    <swiper 
                        class="swiper swiper-wrapper"
                        :options="thumbnailOption" 
                        :navigation="true" 
                        ref="thumbSwiper"
                    >
                    <swiper-slide v-for="(item, idx) in imagesList" :key="`${idx}_im2`">
                        <div class="img_box"><img :src="item.img" alt=""></div>
                    </swiper-slide>
                    </swiper>
                </div>                            
            </article>
                       
        </section>
</template>
<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css';

    export default {
        components: {
            swiper,
            swiperSlide
        },
        mounted () {
            this.$refs.mainSwiper.swiper.controller.control = this.$refs.thumbSwiper.swiper;
            this.$refs.thumbSwiper.swiper.controller.control = this.$refs.mainSwiper.swiper;
        },
        data () {
            return {
                navTitle: ['탕전실 소개', '탕전실 둘러보기'],
                swiperOption: {
                    effect: 'fade',
                    spaceBetween: 10,
                    allowTouchMove: false,
                    loop: true,
                    navigation: {
                        nextEl: '.swiper-next',
                        prevEl: '.swiper-prev'
                    },
                    breakpoints: {
                        1920: { loopedSlides: 6 },
                        1024: { loopedSlides: 5 },
                        768: { loopedSlides: 3.5 },
                        480: { loopedSlides: 2.5 }
                    }                
                },
                thumbnailOption: {
                    spaceBetween: 10,
                    watchSlidesProgress: true,
                    slideToClickedSlide: true,
                    loop: true,
                    breakpoints: {
                        1920: {
                            slidesPerView: 6, 
                            loopedSlides: 6 
                        },
                        1024: {
                            slidesPerView: 5, 
                            loopedSlides: 5 
                        },
                        768: {
                            slidesPerView: 3.5,
                            loopedSlides: 3.5
                        },
                        480: {
                            slidesPerView: 2.5,
                            loopedSlides: 2.5
                        }
                    }                 
                },
                imagesList: [
                    { img: require('@/assets/img/layout/intro18.jpg') },
                    { img: require('@/assets/img/layout/intro1.jpeg') },
                    { img: require('@/assets/img/layout/intro3.jpg') },
                    { img: require('@/assets/img/layout/intro2.jpeg') },
                    { img: require('@/assets/img/layout/intro5.jpeg') },
                    { img: require('@/assets/img/layout/intro6.jpeg') },
                    { img: require('@/assets/img/layout/intro7.jpg') },
                    { img: require('@/assets/img/layout/intro9.jpg') },
                    { img: require('@/assets/img/layout/intro10.jpg') },
                    { img: require('@/assets/img/layout/intro12.jpg') },
                    { img: require('@/assets/img/layout/intro13.jpg') },
                    { img: require('@/assets/img/layout/intro14.jpg') },
                    { img: require('@/assets/img/layout/intro16.jpg') },
                    { img: require('@/assets/img/layout/intro17.jpg') },
                ],                                
            }
        }
    }
</script>